import React, { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import CustomLoading from '../components/uiParts/CustomLoading';
import { AuthContext } from '../contexts/auth';
// ログインでしか入れないページのためのRoute
export const PrivateOutlet = ({
  children
}: {
  children: JSX.Element;
}): JSX.Element => {
  const { currentUser } = useContext(AuthContext);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    typeof currentUser === 'undefined' ? setLoading(true) : setLoading(false);
  }, []);

  return typeof currentUser === 'undefined' ? (
    <CustomLoading loading={loading} />
  ) : currentUser ? (
    children
  ) : (
    <Navigate to="/auth/login" />
  );
};
